module.exports = __webpack_public_path__ + "static/media/cover-products-otc.38c48402.png";